(() => {
  const isHomepageV2 = document.body.classList.contains('template-page-homepage-v2')
    || document.body.classList.contains('template-index');
  const marquees = document.querySelectorAll('[data-homepage-v2-features-marquee]');

  if (!isHomepageV2 || !marquees.length) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  marquees.forEach((element) => {
    const shouldMarquee = () => mobile.matches && !reducedMotion.matches;

    const configure = () => {
      const enabled = shouldMarquee();

      element.classList.toggle('homepage-v2-features-marquee', enabled);

      if (enabled) {
        element.setAttribute('autoplay-delay', '0');
        element.setAttribute('speed', '12000');
        element.setAttribute('free-mode', 'true');
        element.setAttribute('data-mobile-slides-per-view', 'auto');
        element.setAttribute(
          'inject-styles',
          '[":host::part(wrapper) { transition-timing-function: linear !important; }"]'
        );
      } else if (mobile.matches && !element.swiper) {
        element.removeAttribute('autoplay-delay');
        element.removeAttribute('speed');
        element.removeAttribute('free-mode');
        element.removeAttribute('inject-styles');
      }

      const swiper = element.swiper;

      if (!swiper || swiper.destroyed) return;

      if (enabled) {
        swiper.params.speed = 12000;
        swiper.params.freeMode = { enabled: true, momentum: false, sticky: false };
        swiper.params.autoplay = { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false };
        swiper.wrapperEl.style.transitionTimingFunction = 'linear';
        swiper.autoplay?.start();
      } else {
        swiper.autoplay?.stop();
      }
    };

    configure();
    element.addEventListener('swiperafterinit', configure);
    window.addEventListener('resize', configure);
    mobile.addEventListener('change', configure);
    reducedMotion.addEventListener('change', configure);
  });
})();
